import { render, staticRenderFns } from "./hr_Dashboard.vue?vue&type=template&id=18e01076"
import script from "./hr_Dashboard.vue?vue&type=script&lang=js"
export * from "./hr_Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports